import { MeteoHomeForecastTabsMock } from '../MeteoHomeForecastTabsMock/MeteoHomeForecastTabsMock.component';
import { NoCityOverlay } from '../NoCityOverlay/NoCityOverlay.component';
import React, { FC } from 'react';
import styles from '../MeteoHomeLayout/MeteoHomeLayout.module.scss'

export const MeteoHomeTabAndCityMock: FC = () => {
  return (
    <div className={`${styles["forecast-tabs-mock"]} wrapper-s plc-mb-l`}>
      <div className="not-allowed">
        <MeteoHomeForecastTabsMock />
      </div>
      <NoCityOverlay className={`${styles["no-city-overlay"]} `} i18nBody="meteo.no-city-overlay.body" i18nTitle="meteo.no-city-overlay.title" />
    </div>
  );
};
